import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global fetch interceptor - adds auth token to all API requests
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
  const token = localStorage.getItem('token');
  if (token && typeof url === 'string' && (url.includes('/api/') || url.includes('8001'))) {
    options.headers = {
      ...options.headers,
      'Authorization': 'Bearer ' + token
    };
  }
  return originalFetch(url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
